const firebaseConfig_dev = {
  apiKey: 'AIzaSyDdeHJJUPsDnnskiaTrUzsq-99S43JcvGc',
  authDomain: 'data-decoder.firebaseapp.com',
  databaseURL: 'https://data-decoder.firebaseio.com',
  projectId: 'data-decoder',
  storageBucket: 'data-decoder.appspot.com',
  messagingSenderId: '951795803112',
  appId: '1:951795803112:web:2d52b63ce2aee1c65b3a5d',
  measurementId: 'G-9ZCL6GLHKS',
};

export { firebaseConfig_dev };
